import { gql } from '@apollo/client';

import USER_LICENSE_USAGE_FRAGMENT from 'graph/fragments/user-license-usage';

const GET_MY_LICENSE_USAGE = gql`
  query getMyLicenseUsage {
    me {
      id
      licenseUsage {
        ...BaseUserLicenseUsage
      }
    }
  }
  ${USER_LICENSE_USAGE_FRAGMENT}
`;

export default GET_MY_LICENSE_USAGE;
